import { useFormik } from 'formik';
import { initialValues } from './formData';
import { Param } from '../../../../../shared/types/param';

export const usePqrReceptionChannelFilters = (
    onFilter?: (data: Param) => void
) => {
    const onSubmit = (data: Param) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
    };
};
